import React from 'react'
import { Box } from '@mui/material'
import { useEffect } from 'react'
import VehicleDamages from '../../components/VehicleDamages'
import VehiclePhotos from '../../components/VehiclePhotos'
import { VEHICLE_SIDES } from '../../constants'
import { useCache } from '../../hooks/useCache'
import useVehicleId from '../../hooks/useVehicleId'

import { useAppStore } from '../../store/useAppStore'
import { useVehicleDataQuery } from '../../hooks/queries/useVehicleDataQuery'
import { LayoutFor } from '../../types'

const MainBody = ({
  preview,
  layoutFor,
}: {
  preview?: boolean
  layoutFor?: LayoutFor
}) => {
  // External state
  const vehicleData = useAppStore((state) => state.vehicleData)
  const tabValue = useAppStore((state) => state.tabValue)
  const setIsAddVehicleIdDialogVisible = useAppStore(
    (state) => state.setIsAddVehicleIdDialogVisible
  )
  const vehicleId = useVehicleId()

  const {
    damages,
    photos,
    fullPhotos,
    fetchData: getVehicleData,
  } = useVehicleDataQuery()

  const cache = useCache() as { clear: () => Promise<void> } | null

  useEffect(() => {
    if (vehicleId) {
      cache?.clear().finally(() => {
        getVehicleData()
      })
    } else {
      setIsAddVehicleIdDialogVisible(true)
    }
  }, [cache, getVehicleData, setIsAddVehicleIdDialogVisible, vehicleId])

  const currentSideDamages =
    damages[VEHICLE_SIDES[tabValue] as keyof typeof damages]

  return (
    <Box p={1}>
      <>
        {(preview || layoutFor === LayoutFor.IN_ROUTE) && (
          <VehicleDamages
            vehicleDataForCurrentSide={vehicleData[tabValue]}
            damages={currentSideDamages}
            tabValue={tabValue}
          />
        )}
        <VehiclePhotos
          photo={vehicleData[tabValue].photo}
          dateToday={vehicleData[tabValue].date as string}
          in_route={preview || layoutFor === LayoutFor.IN_ROUTE}
          photos={photos}
          fullPhotos={fullPhotos}
          tabValue={tabValue}
          vehicleId={vehicleId as string}
        />
        {!(preview || layoutFor === LayoutFor.IN_ROUTE) && (
          <VehicleDamages
            vehicleDataForCurrentSide={vehicleData[tabValue]}
            damages={currentSideDamages}
            tabValue={tabValue}
          />
        )}
      </>
    </Box>
  )
}

export default MainBody
